import request from '@/utils/request'

// 直播列表
export function getLive(params) {
    return request({
        url: '/console/channels',
        method: 'GET',
        params
    })
}

// 添加直播
export function addLive(params) {
    return request({
        url: '/console/channels',
        method: 'POST',
        data: params
    })
}

// 编辑组织
export function editLive(params, id) {
    return request({
        url: '/console/channels/' + id,
        method: 'PUT',
        data: params
    })
}

// 直播链接
export function liveHref(id) {
    return request({
        url: '/console/channels/' + id + '/live-address',
        method: 'GET'
    })
}

// 组织用户详情
export function detailLive(id) {
    return request({
        url: '/console/channels/' + id,
        method: 'GET'
    })
}

// 获取白名单列表
export function getRosterLive(params, id) {
    return request({
        url: '/console/channels/' + id + '/whitelist',
        method: 'GET',
        params
    })
}

// 导出白名单列表
export function exportRoster(id) {
    return request({
        url: '/console/channels/' + id + '/batch-export-whitelist',
        method: 'GET'
    })
}

// 添加用户
export function addUser(params, id) {
    return request({
        url: '/console/channels/' + id + '/whitelist',
        method: 'POST',
        data: params
    })
}

// 编辑用户
export function editUser(params, id, uid) {
    return request({
        url: '/console/channels/' + id + '/whitelist/' + uid,
        method: 'PUT',
        data: params
    })
}

// 删除用户
export function delUser(id, uid) {
    return request({
        url: '/console/channels/' + id + '/whitelist/' + uid,
        method: 'DELETE'
    })
}

// 设置观看条件
export function authSetting(params, id) {
    return request({
        url: '/console/channels/' + id + '/auth-setting',
        method: 'POST',
        data: params
    })
}

// 直播录制列表
export function getRecord(params, id) {
    return request({
        url: '/console/channels/' + id + '/live-record-list',
        method: 'GET',
        params
    })
}

// 合并录制列表
export function mergeVideo(params, id) {
    return request({
        url: '/console/channels/' + id + '/merge-record',
        method: 'POST',
        data: params
    })
}

// 合并任务
export function mergeTask(id) {
    return request({
        url: '/console/channels/' + id + '/merge-task-list',
        method: 'GET'
    })
}

// 直播评论列表
export function getComment(params, id) {
    return request({
        url: '/console/channels/' + id + '/comment-list',
        method: 'GET',
        params
    })
}

// 直播观看列表
export function getWatch(params, id) {
    return request({
        url: '/console/channels/' + id + '/watch-history-list',
        method: 'GET',
        params
    })
}

// 导出聊天记录
export function exportComment(id) {
    return request({
        url: '/console/channels/' + id + '/export-comment',
        method: 'GET'
    })
}

// 导出观看记录
export function exportWatch(id) {
    return request({
        url: '/console/channels/' + id + '/export-watch-history',
        method: 'GET'
    })
}
